export const baseURL= 'https://szshsurvey.com/api_company';

